/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Workshopexists1Inputs */

const de__field_workshopexists1 = /** @type {(inputs: _Field_Workshopexists1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltung Teilnahme/Anmeldung existiert`)
};

/**

* @param {_Field_Workshopexists1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_workshopexists1 = /** @type {((inputs?: _Field_Workshopexists1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Workshopexists1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_workshopexists1(inputs)
});
export { _field_workshopexists1 as "_field_workshopExists" }